import { render, staticRenderFns } from "./SelectedColors.vue?vue&type=template&id=2122180d&scoped=true&"
import script from "./SelectedColors.vue?vue&type=script&lang=js&"
export * from "./SelectedColors.vue?vue&type=script&lang=js&"
import style0 from "./SelectedColors.vue?vue&type=style&index=0&id=2122180d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2122180d",
  null
  
)

export default component.exports